import { useMemo } from 'react';
import { useQuery } from '@apollo/client';
import { css } from '@emotion/react';
import { pickTextColorBasedOnBgColorSimple } from '../../utils';
import { GetTournamentColorsDocument } from './TournamentStyle.query.generated';
type UseTournamentStyleArgs = {
  clubId?: number;
};
export const useTournamentStyle = ({
  clubId
}: UseTournamentStyleArgs) => {
  const tournamentColorsQuery = useQuery(GetTournamentColorsDocument, {
    variables: {
      clubId
    },
    skip: !clubId,
    context: {
      role: 'anonymous'
    }
  });
  const settings = tournamentColorsQuery?.data?.widgets_club_settings?.[0];
  const cssProp = useMemo(() => {
    if (!settings?.background_color || !settings?.color || !settings?.font_color) {
      return undefined;
    }
    return css`
      --snc-palette-primary-main: ${settings.color};
      --snc-palette-primary-contrastText: ${pickTextColorBasedOnBgColorSimple(settings.color, '#ffffff', '#000000')};
      --snc-palette-text-primary: ${settings.font_color};
      --snc-palette-background-default: ${settings.background_color};
      --snc-palette-secondary-main: ${settings.color};
    `;
  }, [settings]);
  return {
    css: cssProp,
    isReady: tournamentColorsQuery.called && !tournamentColorsQuery.loading
  };
};